import React, { FC } from 'react';
import { Stack } from '@mui/material';

import { CalendarSection } from './CalendarSection';
import { EnergyPreferencesSection } from './EnergyPreferencesSection';
import { FriendsSection } from './FriendsSection';
import { ProfileSection } from './ProfileSection';
import { SubscriptionSection } from './SubscriptionSection';
import { TodosSection } from './TodosSection';
import { WearablesSection } from './WearablesSection';
import { TimeFormatSection } from '../GeneralSection';
import './AccountSection.scss';

const AccountSection: FC = () => {
  return (
    <Stack gap={3} className="account-section">
      <ProfileSection />
      <CalendarSection />
      <TimeFormatSection />
      <WearablesSection />
      <TodosSection />
      <EnergyPreferencesSection />
      <FriendsSection />
      <SubscriptionSection />
    </Stack>
  );
};

export default AccountSection;
